<template>
  <div class="fill-height">
    <v-toolbar class="box-shadow" color="#9190b5"  dark src="https://picsum.photos/1920/1080?random">
      <template v-slot:img="{ props }">
        <v-img v-bind="props" gradient="to top, rgba(25,32,72,.7), rgba(145,144,181,.8)"></v-img>
      </template>
      <v-toolbar-title v-if="session">{{ session.name }}</v-toolbar-title>
      <v-spacer/>
      <vue-clock/>
      <template v-slot:extension>
        <v-tabs centered hide-slider v-if="session" class="blur">
<!--          <v-tab>Start: {{ $moment(session.start).format("DD MMMM YYYY hh:mm A") }}</v-tab>-->
          <template v-if="profile_type && profile_type === 'tutoringSolicitor' || profile_type && profile_type === 'interviewer'">


            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-tab v-bind="attrs" v-on="on">Candidate info</v-tab>
              </template>
              <v-card v-if="session">
                <v-list dense>
                  <v-list-item>
                    <v-list-item-action>
                      <v-icon>mdi-account</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-subtitle>Name</v-list-item-subtitle>
                      <v-list-item-title>{{ session.user.full_name }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider/>

                  <v-list-item>
                    <v-list-item-action>
                      <v-icon>mdi-account</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-subtitle>Nickname</v-list-item-subtitle>
                      <v-list-item-title v-if="session.user.nickname">{{ session.user.nickname }}</v-list-item-title>
                      <v-list-item-subtitle v-else>* Empty *</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider/>

                  <v-list-item>
                    <v-list-item-action>
                      <v-icon>mdi-email</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-subtitle>Email</v-list-item-subtitle>
                      <v-list-item-title>{{ session.user.email }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
                <v-card-actions class="blur">Same sessions</v-card-actions>
                <v-divider/>
                <v-list dense>
                  <v-list-item v-for="item in same_sessions" :key="item.id">
                    <v-list-item-content>{{ item.name }}</v-list-item-content>
                    <v-list-item-action>{{ item.final_mark }}</v-list-item-action>
                  </v-list-item>
                </v-list>
                <v-card-actions class="blur">ISSUES</v-card-actions>
                <v-divider/>
                <v-list dense v-if="session.user && session.user.issues">
                  <v-list-item v-for="item in session.user.issues" :key="item.id">
                    <v-list-item-content>{{ item.type }}</v-list-item-content>
                  </v-list-item>
                </v-list>
                <v-divider/>
                <v-card-actions>
                  <v-btn target="_blank" block color="primary" :to="{name: 'Student', params: {student_id: session.user_id}}">Full candidate info</v-btn>
                </v-card-actions>
              </v-card>
            </v-menu>


            <v-tab v-if="session.parent" @click="parent_session_dialog = !parent_session_dialog">Parent session</v-tab>
          </template>
          <v-tab v-if="session.deadline">Deadline: {{ $moment(session.deadline).format("DD MMMM YYYY hh:mm A") }}</v-tab>
          <template v-if="session_type && session_type === 'AN/CA/IM'">
            <v-tab>Ready
              <v-badge dot :color="session.ready ? 'success': 'error'"></v-badge>
            </v-tab>
            <v-tab>Marked
              <v-badge dot :color="session.marked ? 'success': 'error'"></v-badge>
            </v-tab>
          </template>

          <template v-if="session.zoom_meeting_id">
            <v-tab :href="session.zoom_meeting_id" target="_blank" class="primary white--text">
              <v-icon class="mx-1">mdi-video</v-icon>Connect to meeting
            </v-tab>
          </template>

<!--          <template v-if="profile_type && profile_type === 'tutoringSolicitor' || profile_type && profile_type === 'interviewer'">-->
<!--            <v-tab @click="counter++">Counter {{ counter }} +</v-tab>-->
<!--            <tab-timer></tab-timer>-->
<!--          </template>-->
        </v-tabs>
      </template>
    </v-toolbar>

    <v-navigation-drawer v-if="session" app clipped right v-model="right_drawer">
      <template v-slot:prepend>
        <v-card dark color="primary" tile height="112px" class="d-flex align-center justify-center">
          <vue-clock/>
        </v-card>
        <template v-if="session.zoom_meeting_id">
          <v-btn block :href="session.zoom_meeting_id" target="_blank" class="box-shadow">
            <v-icon class="mx-1">mdi-video</v-icon>
            Connect to meeting
          </v-btn>
        </template>
      </template>
      <v-divider/>

      <v-list-item dense>
        <v-list-item-content>
          <v-list-item-title>Start {{ $moment(session.start).format('DD MMMM YYYY HH:mm') }}</v-list-item-title>
          <v-list-item-subtitle>UK Time zone</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-divider/>

      <template v-if="session.deadline">
        <v-list-item dense>
          <v-list-item-content>
            <v-list-item-title>Submit by {{ $moment(session.deadline).format('DD MMMM YYYY HH:mm') }}</v-list-item-title>
            <v-list-item-subtitle>UK Time zone</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-divider/>
      </template>

      <v-list-item dense>
        <v-list-item-content>
          <v-list-item-title>End {{ $moment(session.end).format('DD MMMM YYYY HH:mm') }}</v-list-item-title>
          <v-list-item-subtitle>UK Time zone</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-divider/>

      <template v-if="session_type">
        <template v-if="session_type !== 'AN/CA/SA' && session_type !== 'interviewer' && session_type !== 'presentation'">
          <v-list-item dense>
            <v-list-item-icon>
              <v-icon>{{ session.ready ? 'mdi-checkbox-marked-outline' : 'mdi-checkbox-blank-outline'}}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>Ready</v-list-item-content>
          </v-list-item>
          <v-divider/>
          <v-list-item dense>
            <v-list-item-icon>
              <v-icon>{{ session.marked ? 'mdi-checkbox-marked-outline' : 'mdi-checkbox-blank-outline'}}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>Marked</v-list-item-content>
          </v-list-item>
          <v-divider/>
        </template>
      </template>

      <btn-timer block></btn-timer>

      <template v-slot:append>
        <template v-if="profile_type && profile_type === 'tutoringSolicitor' || profile_type && profile_type === 'interviewer'">
          <v-btn block depressed @click="counter++">Calculator {{ counter }} +</v-btn>
        </template>
        <template v-if="profile_type && profile_type === 'aspiringSolicitor' && session.marked">
          <v-btn block depressed @click="openReviewDialog">Send feedback</v-btn>
        </template>
        <v-divider/>
        <v-list-item dense>
          <v-list-item-action :class="!right_drawer ? 'ml-n16' : ''">
            <v-btn small color="primary" @click="right_drawer = !right_drawer">
              <v-icon class="mx-1">{{ right_drawer ? 'mdi-chevron-right-box': 'mdi-chevron-left-box'}}</v-icon>
            </v-btn>
          </v-list-item-action>
          <v-list-item-content class="text-no-wrap"></v-list-item-content>
        </v-list-item>
      </template>
    </v-navigation-drawer>

    <Presentation v-if="session_type === 'presentation'"
                  :session="session"
                  @loadSession="loadData"
                  @sessionReady="makeSessionReady"
                  @sessionMarked="makeSessionMarked"
                  @sessionUnready="makeSessionUnready"
    ></Presentation>

    <Interview v-if="session_type === 'interview'"
               :session="session"
               @loadSession="loadData"
               @sessionReady="makeSessionReady"
               @sessionMarked="makeSessionMarked"
               @sessionUnready="makeSessionUnready"
    ></Interview>


    <ANCAIM v-if="session_type === 'AN/CA/IM'"
            :session="session"
            @loadSession="loadData"
            @sessionReady="makeSessionReady"
            @sessionMarked="makeSessionMarked"
            @sessionUnready="makeSessionUnready"
    ></ANCAIM>

    <ANCASA v-if="session_type === 'AN/CA/SA'"
            :session="session"
            @loadSession="loadData"
            @sessionReady="makeSessionReady"
            @sessionMarked="makeSessionMarked"
            @sessionUnready="makeSessionUnready"
    ></ANCASA>

    <LegalWriting v-if="session_type === 'legal_writing' || session_type === 'legal_drafting' || session_type === 'legal_research'"
                  :session="session"
                  @loadSession="loadData"
                  @sessionReady="makeSessionReady"
                  @sessionMarked="makeSessionMarked"
                  @sessionUnready="makeSessionUnready"
    ></LegalWriting>

    <template v-if="authUser && session && authUser.id === session.tutor_id">
      <v-container fluid v-if="session_type === 'legal_writing'
        || session_type === 'legal_drafting'
        || session_type === 'legal_research'
        || session_type === 'AN/CA/IM'
      ">
        <v-card class="mt-4">
          <v-toolbar dense dark color="primary">Return for resubmission</v-toolbar>
          <v-divider></v-divider>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title></v-list-item-title>
              <v-textarea outlined label="Comment" v-model="unready_comment"></v-textarea>
            </v-list-item-content>
            <v-list-item-action>
              <v-btn @click="makeSessionUnready" color="primary" small :disabled="!unready_comment">Return</v-btn>
            </v-list-item-action>
          </v-list-item>
        </v-card>
      </v-container>

      <v-container fluid>
        <v-row>
          <v-col cols="12" md="6">
            <v-card class="mb-3">
              <v-toolbar color="primary" dark dense>Review (internal use)</v-toolbar>
              <vue-editor v-model="session.internal_review" :editor-toolbar="toolbar" @input="debounceUpdateSession"/>
            </v-card>


          </v-col>
          <v-col cols="12" md="6">
            <MarkCalculator v-model="session.marks" :final_mark="session.final_mark" @finalMarkUpdated="setFinalMark"/>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-card>
              <v-alert dark prominent color="primary" icon="mdi-school" class="mb-0">
                Write your own review for the candidate
              </v-alert>

              <v-sheet class="overflow-y-auto" min-height="200px" max-height="500px">
                <vue-editor v-model="session.review" :editor-toolbar="toolbar" @input="debounceUpdateSession"/>
              </v-sheet>
            </v-card>
          </v-col>
        </v-row>

      </v-container>

      <v-container fluid>
        <v-card>
          <v-alert dark prominent color="primary" icon="mdi-school">
            <v-row align="center">
              <v-col class="grow">
                Before submitting your feedback, please make sure it is fully completed
              </v-col>
              <v-col class="shrink">
                <v-btn @click="send_feedback_dialog =!send_feedback_dialog">
                  {{ session.marked ? 'Done!' : 'Submit your feedback' }}
                </v-btn>
              </v-col>
            </v-row>
          </v-alert>
        </v-card>
      </v-container>

    </template>

    <v-dialog v-model="student_review_dialog" @click:outside="closeReviewDialog" max-width="600px">
      <v-form v-if="student_review">
        <v-card>
          <v-toolbar dense dark color="primary">
            Send feedback <v-spacer></v-spacer>
            <v-btn icon @click="closeReviewDialog"><v-icon>mdi-close</v-icon></v-btn>
          </v-toolbar>
          <v-card-text class="pt-0" v-if="session_type === 'presentation' || session_type === 'interview'">
            <v-subheader>How would you rate the tutor's performance?</v-subheader>
            <v-rating v-model="student_review.tutor_rating"
                      class="text-center"
                      color="yellow darken-3"
                      background-color="grey darken-1"
                      empty-icon="$ratingFull"
                      half-increments hover
            ></v-rating>
            <v-textarea v-model="student_review.tutor_review" outlined dense hide-details/>
          </v-card-text>

          <v-card-text class="">
            <v-subheader> How would you rate the difficulty of the task you have been set in this mock session?
              (on a scale 1 to 5, with 1 being not difficult, and 5 being very difficult)</v-subheader>
            <v-rating v-model="student_review.mock_rating"
                      class="text-center"
                      color="yellow darken-3"
                      background-color="grey darken-1"
                      empty-icon="$ratingFull"
                      half-increments hover
            ></v-rating>
            <v-textarea v-model="student_review.mock_review" outlined dense hide-details/>
          </v-card-text>
          <v-divider/>
          <v-card-actions>
            <v-btn small text @click="closeReviewDialog">cancel</v-btn>
            <v-spacer/>
            <v-btn small color="primary" @click="sendReview">Send feedback</v-btn>

          </v-card-actions>
        </v-card>
      </v-form>

    </v-dialog>

    <v-dialog v-model="send_feedback_dialog" max-width="500px">
      <v-card>
        <v-toolbar color="primary" dense dark>Send feedback</v-toolbar>
        <v-card-text class="mt-3 text-center">
          <p class="ma-0">This feedback will be sent to the <span style="color: red">CANDIDATE</span>.</p>
          Are you sure that you want to submit it?
        </v-card-text>
        <v-divider/>
        <v-card-actions class="justify-space-between">
          <v-btn text @click="send_feedback_dialog = !send_feedback_dialog">Cancel</v-btn>
          <v-btn color="primary" @click="makeSessionMarked">Submit</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="session_info_dialog" v-if="session && session.mock && session_info_dialog"
              max-width="800px" :overlay-opacity="0.95">
      <v-card>
        <v-toolbar dense color="primary"></v-toolbar>
        <v-sheet class="overflow-y-auto" max-height="400px">
          <v-card-text class="ql-editor" v-if="authUser && authUser.id === session.tutor_id"
                       v-html="session.mock.tutor_instruction"/>
          <v-card-text class="ql-editor" v-if="authUser && authUser.id === session.user_id"
                       v-html="session.mock.candidate_instruction"/>
        </v-sheet>
        <v-divider/>
        <v-card-actions class="justify-center">
          <v-btn color="success" @click="session_info_dialog = !session_info_dialog">Proceed</v-btn>
        </v-card-actions>

      </v-card>
    </v-dialog>

    <v-dialog v-model="user_info_dialog" max-width="500px">
      <v-card v-if="session && session.user">
        <v-toolbar flat dense>Candidate</v-toolbar>
        <v-divider/>
        <v-list dense>
          <v-list-item>
            <v-list-item-action>
              <v-icon>mdi-account</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-subtitle>Name</v-list-item-subtitle>
              <v-list-item-title>{{ session.user.full_name }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider/>

          <v-list-item>
            <v-list-item-action>
              <v-icon>mdi-account</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-subtitle>Nickname</v-list-item-subtitle>
              <v-list-item-title v-if="session.user.nickname">{{ session.user.nickname }}</v-list-item-title>
              <v-list-item-subtitle v-else>* Empty *</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-divider/>

          <v-list-item>
            <v-list-item-action>
              <v-icon>mdi-email</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-subtitle>Email</v-list-item-subtitle>
              <v-list-item-title>{{ session.user.email }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider/>

          <v-list-item>
            <v-list-item-action>
              <v-icon>mdi-star</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-subtitle>Rating</v-list-item-subtitle>
              <v-list-item-subtitle>{{ session.user.rating }}</v-list-item-subtitle>
            </v-list-item-content>
            <!--                <v-list-item-action>-->
            <!--                  <v-rating dense disabled :value="session.user.rating"/>-->
            <!--                </v-list-item-action>-->
          </v-list-item>
        </v-list>
      </v-card>
    </v-dialog>

    <v-dialog v-model="parent_session_dialog" max-width="800px">
      <template v-if="session && session.parent">
        <v-card tile class="my-3">
          <v-toolbar dense>{{ session.parent.name }}</v-toolbar>
          <v-subheader>Internal review</v-subheader>
          <v-card-text v-if="session.parent.internal_review" v-html="session.parent.internal_review"/>
          <v-divider/>
          <v-subheader>Review</v-subheader>
          <v-card-text v-if="session.parent.review" v-html="session.parent.review"/>
          <v-divider/>
          <v-subheader v-if="session.parent.tasks">Marksheet</v-subheader>
          <v-list dense v-if="session.parent.tasks">
            <v-list-item class="v-sheet--outlined" v-for="item in session.parent.tasks" :key="item.id">
              <v-list-item-content>{{ item.body }}</v-list-item-content>
              <v-list-item-icon><v-icon>{{ item.mark === '0' ? 'mdi-close' : 'mdi-check' }}</v-icon></v-list-item-icon>
            </v-list-item>
          </v-list>
        </v-card>
        <MarkViewer :marks="session.parent.marks" :final_mark="session.parent.final_mark"/>
      </template>
    </v-dialog>

    <!--    <v-overlay v-if="show_not_started_overlay" absolute="absolute" opacity="1">-->
    <!--      <v-alert prominent type="primary" icon="mdi-school">-->
    <!--        <v-row align="center">-->
    <!--          <v-col class="grow">-->
    <!--            The session has not started yet. Access will be open 30 minutes before start-->
    <!--          </v-col>-->
    <!--          <v-col class="shrink">-->
    <!--            <v-btn @click="$router.back()">Turn back</v-btn>-->
    <!--          </v-col>-->
    <!--        </v-row>-->
    <!--      </v-alert>-->
    <!--    </v-overlay>-->
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import _ from "lodash";
export default {
  components: {
    MarkCalculator:() => import("@/components/MarkCalculator"),
    MarkViewer:() => import("@/components/MarkViewer"),
    Presentation:() => import("./Presentation"),
    Interview:() => import("./Interview"),
    ANCAIM:() => import("./ANCAIM"),
    ANCASA:() => import("./ANCASA"),
    LegalWriting:() => import("./LegalWriting"),
  },
  data: () => ({
    drawer: false,
    right_drawer: true,
    session: null,
    same_sessions: [],
    session_info_dialog: true,
    user_info_dialog: false,
    parent_session_dialog: false,
    show_instruction:true,
    show_marksheet:true,
    show_mark_calculator:true,
    show_mark_criteria:true,
    mark_sheet_headers: [
      { text: 'Field', value: 'body' },
      { text: 'Answered', value: 'mark' },
      { text: 'Comments', value: 'comment', width: '150px' },
    ],
    marking_criteria_headers: [
      { text: 'Mark', value: 'mark' },
      { text: '%', value: 'percent'},
      { text: '', value: 'pass'},
    ],
    marking_criteria_items: [
      {mark: 'A', percent: '100'},
      {mark: 'B', percent: '80'},
      {mark: 'C', percent: '60', pass: 'pass'},
      {mark: 'D', percent: '40'},
      {mark: 'E', percent: '20'},
      {mark: 'F', percent: '0'},
      {mark: 'G', percent: 'N/A'},
    ],
    toolbar: [
      [{ header: [false, 1, 2, 3, 4, 5, 6] }, "bold", "italic", "underline"],
      [{align:""}, {align:"center"}, {align:"right"}, {align:"justify"}],
      [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
      [{ indent: "-1" }, { indent: "+1" }],
      [{ color: [] }, { background: []}],
      ["blockquote", "code-block"],
      ["link", "image", "formula"],
    ],

    send_feedback_dialog: false,
    counter: 0,

    unready_comment: '',

    student_review: null,
    student_review_dialog: false,

    rating_items: [
      {text: 'A', value: 5},
      {text: 'B', value: 4},
      {text: 'C', value: 3},
      {text: 'D', value: 2},
      {text: 'E', value: 1},
      {text: 'F', value: 0},
    ],
  }),
  computed: {
    ...mapGetters({profile_type: 'getAuthUserProfileType'}),
    session_type: function () {
      if(this.session && this.session.session_type) {
        return this.session.session_type.tech_name
      }
      else
        return null
    },
    show_not_started_overlay: function () {
      if(this.session) {
        let open_time = this.$moment(this.session.start).subtract(30, 'minutes')
        let diff = open_time.diff(this.$currentTime().format())
        return diff > 0
      }
      return true
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    loadData() {
      this.app_loading = true
      this.axios.get(`api/user/sessions/${this.$route.params.session_id}`)
          .then(({data}) => {
            this.session = data.data
            this.loadSameSessions()
          })
          .catch(errors => {
            if(errors.response.status === 403) {this.$router.back()}
            if(errors.response.status === 404) {this.$router.back()}
          })
          .then(() => {this.app_loading = false})
    },
    loadSameSessions() {
      this.app_loading = true
      this.axios.get(`api/students/${this.session.user_id}/sessions`, {params: {
          session_type_id: this.session.session_type_id,
          // practice_area_id: this.session.practice_area_id,
        }})
          .then(({data}) => {this.same_sessions = data.data})
          .catch(errors => {
            if(errors.response.status === 403) {this.$router.back()}
            if(errors.response.status === 404) {this.$router.back()}
          })
          .then(() => {this.app_loading = false})
    },


    setFinalMark(mark) {
      this.session.final_mark = mark
      this.updateSession()
    },
    updateSession() {
      this.axios.put(`api/user/sessions/${this.$route.params.session_id}`, {
        internal_review: this.session.internal_review,
        review: this.session.review,
        marks: this.session.marks,
        final_mark: this.session.final_mark,
      })
    },
    debounceUpdateSession:_.debounce(function () { this.updateSession()}, 3000),
    makeSessionReady() {
      this.app_loading = true
      this.axios.put(`api/user/sessions/${this.$route.params.session_id}/ready`, {ready: true})
          .then(({data}) => {
            this.session = data.data
            this.$notify('Success!', 'success')
          })
          .catch(errors => {console.log(errors)})
          .then(() => {this.app_loading = false})
    },
    makeSessionUnready() {
      this.app_loading = true
      this.axios.put(`api/user/sessions/${this.$route.params.session_id}/unready`, {
        ready: false,
        comment: this.unready_comment
      })
          .then(({data}) => {
            this.session = data.data
            this.$notify('Success!', 'success')
          })
          .catch(errors => {console.log(errors)})
          .then(() => {this.app_loading = false})
    },
    makeSessionMarked() {
      this.app_loading = true
      this.axios.put(`api/user/sessions/${this.$route.params.session_id}/marked`, {marked: true})
          .then(({data}) => {
            this.session = data.data
            this.send_feedback_dialog = false
            this.$notify('Success!', 'success')
          })
          .catch(errors => {console.log(errors)})
          .then(() => {this.app_loading = false})
    },

    openReviewDialog() {
      this.student_review = {
        tutor_rating: 0,
        tutor_review: '',
        mock_rating: 0,
        mock_review: '',
      }
      this.student_review_dialog = true
    },
    closeReviewDialog() {
      this.student_review = null
      this.student_review_dialog = false
    },
    sendReview() {
      this.app_loading = true
      this.axios.post(`api/user/sessions/${this.$route.params.session_id}/review`, this.student_review)
          .then(({data}) => {
            console.log(data)
            this.closeReviewDialog()
            this.$notify('Success!', 'success')

          })
          .catch(errors => {console.log(errors)})
          .then(() => {this.app_loading = false})
    },

  }
}
</script>
